import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { channelOperations } from '../../../../../models/channels';
import {
  trackChannelFollow,
  trackChannelUnfollow,
} from '../../../../../models/channels/analytics';
import { Button, Icon } from '@socialchorus/shared-ui-components';
import { useFollowChannelButtonState } from '../../../../../common/channel/use-follow-channel-button-state';
import { ChannelButtonTooltip } from '../../../../channel/channel-button-tooltip';

const FollowButton = ({
  topicId,
  analyticsData,
  onFollowUnfollow,
}: {
  topicId: string;
  analyticsData: IAnalyticsData;
  onFollowUnfollow?: (following: boolean) => void;
}): JSX.Element => {
  const dispatch = useDispatch();
  const { label, following, disabled, aria } = useFollowChannelButtonState({
    channelId: topicId,
  });

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      if (following) {
        dispatch(channelOperations.unfollowChannel(topicId));
        trackChannelUnfollow(topicId, analyticsData);
      } else {
        dispatch(channelOperations.followChannel(topicId));
        trackChannelFollow(topicId, analyticsData);
      }

      if (onFollowUnfollow) {
        onFollowUnfollow(following);
      }
    },
    [dispatch, topicId, analyticsData, following, onFollowUnfollow]
  );

  return (
    <ChannelButtonTooltip channelId={topicId}>
      <Button
        variant={following ? 'outline' : 'primary'}
        size="compact"
        label={label}
        disabled={disabled}
        leftIcon={<Icon>{following ? 'done' : 'add'}</Icon>}
        onClick={handleClick}
        style={{ zIndex: 1 }} //needs to be higher than the pseudo link on the card body
        {...aria}
      />
    </ChannelButtonTooltip>
  );
};

export default FollowButton;
